import bobtailAPI from '../axiosConfig'
import Entity from './entity'

const DebtorDocument = new Entity('debtordocuments')

DebtorDocument.sendDocument = async (params) => {
  return (await bobtailAPI()).post(`${DebtorDocument.baseUrl}/send-document/${params.id}`, {
    ...params,
  })
}

export default DebtorDocument
